import { render } from "./ModalContact.vue?vue&type=template&id=b68af106"
import script from "./ModalContact.vue?vue&type=script&lang=js"
export * from "./ModalContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__